<template>
  <div class="session-card-div mx-auto">
    <v-container class="session-card-main d-flex align-end flex-column">
      <v-container class="pa-0">
        <v-row class="pb-0 pt-1" v-if="session.sessionType">
          <v-col class="pb-2">
            <span
              class="session-card-type rounded-pill pa-2 px-4"
              :style="sessionTypeStyle()">
              {{ session.sessionType }}
            </span>
          </v-col>
        </v-row>

        <v-row class="pb-0">
          <v-col class="pb-0">
            <h3>{{ session.name }}</h3>
          </v-col>
        </v-row>
        <v-row class="pt-0">
          <v-col class="pt-0">
            <b>{{ $t("daySchedule.speakers") }}:</b>&nbsp;
            <span v-if="session.speakers.length == 0">{{
              $t("sessionSchedule.tbc")
            }}</span>
            <span
              v-else
              v-for="(speaker, i) in session.speakers"
              :key="'speaker' + i">
              {{ i != session.speakers.length - 1 ? speaker + ", " : speaker }}
            </span>
          </v-col>
        </v-row>
      </v-container>
      <v-container class="pl-0 pt-5 pb-5">
        <v-row>
          <v-col class="py-1">
            <v-icon class="pr-1">mdi-clock-outline</v-icon>
            {{ getTime(session.start, session.end) }}
          </v-col>
        </v-row>
        <v-row v-if="session.type != null && session.type.length > 0">
          <v-col class="py-1">
            <v-icon class="pr-1">mdi-map-marker-outline</v-icon>
            {{ session.type }}
          </v-col>
        </v-row>
        <v-row v-if="session.languages != null && session.languages.length > 0">
          <v-col class="py-1 pb-0">
            <v-icon class="pr-1">mdi-web</v-icon>
            {{ session.languages }}
          </v-col>
        </v-row>
        <v-row class="pb-5 pt-0">
          <v-col class="pb-5">
            <v-btn
              :disabled="session.hasDetails == false"
              class="learn-more pa-0 ma-0"
              text
              @click="openSession(session.id)"
              >{{ $t("daySchedule.learnMore") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <session-schedule-dialog
      :isOpen="isSessionInfoOpen"
      @closed="isSessionInfoOpen = !$event">
    </session-schedule-dialog>
  </div>
</template>

<script>
import SessionScheduleDialog from "./SessionScheduleDialog";

export default {
  name: "SessionCard",
  data() {
    return {
      isSessionInfoOpen: false,
    };
  },
  props: {
    session: {
      type: Object,
      required: true,
    },
  },
  computed: {
    daySelected: {
      get() {
        return this.$store.getters["getDaySelected"];
      },
      set(day) {
        return this.$store.dispatch("changeDaySelected", day);
      },
    },
    sessionSelected: {
      get() {
        return this.$store.getters["getSessionSelected"];
      },
      set(day) {
        return this.$store.dispatch("changeSessionSelected", day);
      },
    },
  },
  methods: {
    sessionTypeStyle() {
      var style = "background-color: #fafafa;";
      var color = this.session.categoryBackgroundColor;
      if (color == "#d9e0e4") color = "#000";
      style += "color:" + color + ";";

      return style;
    },
    openSession(sessionId) {
      this.fetchSessionSelectedDetails({
        id: sessionId,
      }).then((this.isSessionInfoOpen = true));
    },
    async fetchSessionSelectedDetails(params) {
      await this.$store.dispatch("fetchSessionSelectedDetails", params);
    },
    getTime(start, end) {
      if (this.$dayjs(start).get("hour") == 0 || end == null) {
        return this.$t("calendar.onDemand");
      } else {
        return (
          this.$dayjs(start).format("HH:mm") +
          " - " +
          this.$dayjs(end).format("HH:mm")
        );
      }
    },
  },
  components: {
    "session-schedule-dialog": SessionScheduleDialog,
  },
};
</script>
